import { useState, useEffect, useMemo } from 'react';
import { FieldType } from 'common/consts/fieldType';
import styles from './EditAddressPageData.module.scss';
import { fetcher } from 'app/http';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';
import qs from 'qs';
import FormSelect from 'components/FormSelect/FormSelect';
import classNames from 'classnames/bind';
import PrefixSelect, {
  ICountryPrefix,
} from 'components/PhoneInput/PrefixSelect/PrefixSelect';
import { formProgression, formError } from 'common/helpers/Gtm';
import { useHistory } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { useAppSelector } from 'app/hooks';
import { selectCurrentMarket } from 'features/core/selectors';
import { Market } from 'common/consts/markets';
import UpdatedFailedPopup from 'components/UpdateFailedPopup/UpdateFailedPopup';
interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
  editAddressFormModel?: any;
  setEditAddressFormModel?: any;
  setEditAddressSubmitting?: any;
  setEditAddressConfirmationData?: any;
  setShowAddress?: any;
  onCancel: () => void;
}

const EditAddressPageData = ({
  PageData,
  Model,
  LayoutModel,
  editAddressFormModel,
  setEditAddressFormModel,
  setEditAddressSubmitting,
  setEditAddressConfirmationData,
  setShowAddress,
  onCancel,
}: Props) => {
  const [content, setContentPage] = useState<any>({ Model, PageData, LayoutModel });
  const currentMarket = useAppSelector(selectCurrentMarket);
  const [showValidation, setShowValidation] = useState<any>(false);
  const [showUpdateFailedPopup, setShowUpdateFailedPopup] = useState<boolean>(Model?.UpdateFailed);
  let addressValues = { ...editAddressFormModel };
  const history = useHistory();

  function onChangeInputHandler(e: any) {
    addressValues[e.target.name] = e.target.value;
    setEditAddressFormModel(addressValues);
  }
  function onChangeInputCountry(e: string) {
    addressValues['Country'] = e;
    (content?.Model.Countries || []).map(
      (element: ICountryPrefix) => (
        (element.Selected = false),
        element.Text == e &&
        ((addressValues['CountryCode'] = element.Value),
          (element.Selected = true))
      ),
    );

    setEditAddressFormModel(addressValues);
  }
  useEffect(() => {
    setContentPage({ Model, PageData, LayoutModel });
  }, [Model, PageData, LayoutModel]);

  const handleFormSubmit = async (e: any) => {
    setShowValidation(false);
    e.preventDefault();
    try {
      const response = await fetcher.post(
        content?.Model.SaveChangesPageUrl,
        // Convert object into string
        qs.stringify({
          FormModel: { ...editAddressFormModel, FlatNumber: '' },
        }),
      );
      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state

        if (response.data.status) {
          if (response.data.status === 'error') {
            var nextPagePath = getPathnameFromUrl(response.data.data);
            history.push(nextPagePath, {
              noRefresh: false,
            });
            return;
          }
        }
        if (response && response.data && response.data.RedirectUrl) {
          const responseConfirmData = await fetcher.get(
            getPathnameFromUrl(response.data.RedirectUrl),
          );
          if (responseConfirmData && responseConfirmData.data) {
            setEditAddressConfirmationData(responseConfirmData.data);
            setShowAddress(false);
            setEditAddressSubmitting(true);
            detailsAddressTracking();
          }
        } else if (response && response.data) {
          setContentPage({
            PageData: response?.data?.PageData,
            Model: response?.data?.Model,
            LayoutModel: response?.data?.LayoutModel
          });
          setShowAddress(true);
          setShowValidation(true);
          setShowUpdateFailedPopup(response?.data?.Model?.UpdateFailed);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
  var tagManagerArgs: any;
  const detailsAddressTracking = () => {
    tagManagerArgs = {
      dataLayer: {
        event: 'edit_profile',
        edit_section: 'Address',
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.section}>
        <div className="Modal-content">
          <form
            id="editAdressForm"
            className="Form Form-inputIndent Modal-form"
            onSubmit={handleFormSubmit}
          >
            <div className="Grid Grid--gutterA Grid--gutter-sm-Bz data-hj-suppress">
              <div className="Grid-cell  u-lg-size1of1 u-paddingBz">
                <h3 className="Heading Heading-h3--portal u-marginBz">
                  {PageData?.Header}
                </h3>
              </div>
              <div className="Grid-cell  u-lg-size1of2">
                {content?.Model?.ContactDetailsConfiguration?.addressFields
                  ?.addressLine1 === FieldType.Editable && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData?.AddressLine1}
                      </label>
                      <div className="Input ">
                        <input
                          type="text"
                          id="QUE_adress1"
                          name="AddressLine1"
                          value={editAddressFormModel.AddressLine1}
                          onChange={(val) => {
                            onChangeInputHandler(val);
                          }}
                          className={classNames(
                            styles.input,
                            !editAddressFormModel.AddressLine1 && showValidation
                              ? 'input-validation-error'
                              : styles.input,
                          )}
                          onBlur={(e) =>
                            formProgression(
                              e,
                              'Profile address form',
                              'AddressLine1',
                            )
                          }
                        />
                        {!editAddressFormModel.AddressLine1 &&
                          showValidation &&
                          (content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.addressLine1 ===
                            FieldType.Editable ||
                            content?.Model?.ContactDetailsConfiguration
                              ?.addressFields?.addressLine1 ===
                            FieldType.FixedValues) && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingAddressLine1Error}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}

                {content?.Model?.ContactDetailsConfiguration?.addressFields
                  .addressLine2 === FieldType.Editable && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData?.AddressLine2}
                      </label>
                      <div className="Input">
                        <input
                          type="text"
                          id="QUE_adress2"
                          name="AddressLine2"
                          value={editAddressFormModel.AddressLine2}
                          onChange={(val) => {
                            onChangeInputHandler(val);
                          }}
                          className={classNames(
                            styles.input,
                            !editAddressFormModel.AddressLine2 && showValidation
                              ? 'input-validation-error'
                              : styles.input,
                          )}
                          onBlur={(e) =>
                            formProgression(
                              e,
                              'Profile address form',
                              'AddressLine2',
                            )
                          }
                        />
                        {!editAddressFormModel.AddressLine2 &&
                          showValidation &&
                          (content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.addressLine2 ===
                            FieldType.Editable ||
                            content?.Model?.ContactDetailsConfiguration
                              ?.addressFields?.addressLine2 ===
                            FieldType.FixedValues) && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingAddressLine2Error}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}
                {content?.Model?.ContactDetailsConfiguration.addressFields
                  .addressLine3 === FieldType.Editable && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData?.AddressLine3}
                      </label>
                      <div className="Input">
                        <input
                          type="text"
                          id="QUE_adress3"
                          name="AddressLine3"
                          value={editAddressFormModel.AddressLine3}
                          onChange={(val) => {
                            onChangeInputHandler(val);
                          }}
                          className={classNames(
                            styles.input,
                            !editAddressFormModel.AddressLine3 && showValidation
                              ? 'input-validation-error'
                              : styles.input,
                          )}
                          onBlur={(e) =>
                            formProgression(
                              e,
                              'Profile address form',
                              'AddressLine3',
                            )
                          }
                        />
                        {!editAddressFormModel.AddressLine3 &&
                          showValidation &&
                          (content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.addressLine3 ===
                            FieldType.Editable ||
                            content?.Model?.ContactDetailsConfiguration
                              ?.addressFields?.addressLine3 ===
                            FieldType.FixedValues) && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingAddressLine3Error}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}

                {content?.Model?.ContactDetailsConfiguration.addressFields
                  .addressLine4 === FieldType.Editable && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData?.AddressLine4}
                      </label>
                      <div className="Input">
                        <input
                          type="text"
                          id="QUE_adress4"
                          name="AddressLine4"
                          value={editAddressFormModel.AddressLine4}
                          onChange={(val) => {
                            onChangeInputHandler(val);
                          }}
                          className={classNames(
                            styles.input,
                            !editAddressFormModel.AddressLine4 && showValidation
                              ? 'input-validation-error'
                              : styles.input,
                          )}
                          onBlur={(e) =>
                            formProgression(
                              e,
                              'Profile address form',
                              'AddressLine4',
                            )
                          }
                        />
                        {!editAddressFormModel.AddressLine4 &&
                          showValidation &&
                          (content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.addressLine4 ===
                            FieldType.Editable ||
                            content?.Model?.ContactDetailsConfiguration
                              ?.addressFields?.addressLine4 ===
                            FieldType.FixedValues) && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingAddressLine4Error}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}

                {content?.Model?.ContactDetailsConfiguration.addressFields
                  .addressLine5 === FieldType.Editable && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData?.AddressLine5}
                      </label>
                      <div className="Input">
                        <input
                          type="text"
                          id="QUE_adress5"
                          name="AddressLine5"
                          value={editAddressFormModel.AddressLine5}
                          onChange={(val) => {
                            onChangeInputHandler(val);
                          }}
                          className={classNames(
                            styles.input,
                            !editAddressFormModel.AddressLine5 && showValidation
                              ? 'input-validation-error'
                              : styles.input,
                          )}
                          onBlur={(e) =>
                            formProgression(
                              e,
                              'Profile address form',
                              'AddressLine5',
                            )
                          }
                        />
                        {!editAddressFormModel.AddressLine5 &&
                          showValidation &&
                          (content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.addressLine5 ===
                            FieldType.Editable ||
                            content?.Model?.ContactDetailsConfiguration
                              ?.addressFields?.addressLine5 ===
                            FieldType.FixedValues) && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingAddressLine5Error}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}
                {content?.Model?.ContactDetailsConfiguration.addressFields
                  .streetName === FieldType.Editable && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData?.StreetName}
                      </label>
                      <div className="Input">
                        <input
                          type="text"
                          id="QUE_street"
                          name="StreetName"
                          value={editAddressFormModel.StreetName}
                          onChange={(val) => {
                            onChangeInputHandler(val);
                          }}
                          className={classNames(
                            styles.input,
                            !editAddressFormModel.StreetName && showValidation
                              ? 'input-validation-error'
                              : styles.input,
                          )}
                          onBlur={(e) =>
                            formProgression(
                              e,
                              'Profile address form',
                              'StreetName',
                            )
                          }
                        />
                        {!editAddressFormModel.StreetName &&
                          showValidation &&
                          (content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.streetName === FieldType.Editable ||
                            content?.Model?.ContactDetailsConfiguration
                              ?.addressFields?.streetName ===
                            FieldType.FixedValues) && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingStreetNameError}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}
                {content?.Model?.ContactDetailsConfiguration.addressFields
                  .houseNumber === FieldType.Editable && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData?.HouseNumber}
                      </label>
                      <div className="Input">
                        <input
                          type="text"
                          id="QUE_housenumber"
                          name="HouseNumber"
                          value={editAddressFormModel.HouseNumber}
                          onChange={(val) => {
                            onChangeInputHandler(val);
                          }}
                          className={classNames(
                            styles.input,
                            !editAddressFormModel.HouseNumber && showValidation
                              ? 'input-validation-error'
                              : styles.input,
                          )}
                          onBlur={(e) =>
                            formProgression(
                              e,
                              'Profile address form',
                              'HouseNumber',
                            )
                          }
                        />
                        {!editAddressFormModel.HouseNumber &&
                          showValidation &&
                          (content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.houseNumber === FieldType.Editable ||
                            content?.Model?.ContactDetailsConfiguration
                              ?.addressFields?.houseNumber ===
                            FieldType.FixedValues) && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingHouseNumberError}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}
              </div>
              <div className="Grid-cell  u-lg-size1of2">
                {content?.Model?.ContactDetailsConfiguration.addressFields
                  .postalCode === FieldType.Editable && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData?.Postcode}
                      </label>
                      <div className="Input">
                        <input
                          type="text"
                          id="QUE_postalcode"
                          name="Postcode"
                          maxLength={currentMarket === Market.ES ? 5 : undefined}
                          value={editAddressFormModel.Postcode}
                          onChange={(val) => {
                            onChangeInputHandler(val);
                          }}
                          className={classNames(
                            styles.input,
                            !editAddressFormModel.Postcode && showValidation
                              ? 'input-validation-error'
                              : styles.input,
                          )}
                          onBlur={(e) =>
                            formProgression(e, 'Profile address form', 'Postcode')
                          }
                        />
                        {!editAddressFormModel.Postcode &&
                          showValidation &&
                          (content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.postalCode === FieldType.Editable ||
                            content?.Model?.ContactDetailsConfiguration
                              ?.addressFields?.postalCode ===
                            FieldType.FixedValues) && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingPostcodeError}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}
                {content?.Model?.ContactDetailsConfiguration.addressFields
                  .city === FieldType.Editable && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData?.City}
                      </label>
                      <div className="Input">
                        <input
                          type="text"
                          id="QUE_city"
                          name="City"
                          value={editAddressFormModel.City}
                          onChange={(val) => {
                            onChangeInputHandler(val);
                          }}
                          className={classNames(
                            styles.input,
                            !editAddressFormModel.City && showValidation
                              ? 'input-validation-error'
                              : styles.input,
                          )}
                          onBlur={(e) =>
                            formProgression(e, 'Profile address form', 'City')
                          }
                        />
                        {!editAddressFormModel.City &&
                          showValidation &&
                          (content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.city === FieldType.Editable ||
                            content?.Model?.ContactDetailsConfiguration
                              ?.addressFields?.city ===
                            FieldType.FixedValues) && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingCityError}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}
                {content?.Model?.ContactDetailsConfiguration?.addressFields
                  ?.country === FieldType.FixedValues && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData?.Country}
                      </label>
                      <div>
                        <FormSelect
                          value={editAddressFormModel.Country}
                          options={
                            content?.Model.Countries.map(
                              (element: ICountryPrefix) => element.Text,
                            ) || []
                          }
                          onChange={(val) => {
                            onChangeInputCountry(val);
                          }}
                        />
                        {!editAddressFormModel.CountryCode &&
                          showValidation &&
                          content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.country ===
                          FieldType.FixedValues && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingCountryError}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}

                {content?.Model?.ContactDetailsConfiguration.addressFields
                  .country === FieldType.Editable && (
                    <>
                      <label className="Label Form-label">
                        {content?.PageData.Country}
                      </label>
                      <div className="Input">
                        <input
                          type="text"
                          id="QUE_country"
                          name="Country"
                          value={editAddressFormModel.Country}
                          onChange={(val) => {
                            onChangeInputHandler(val);
                          }}
                          className={classNames(
                            styles.input,
                            !editAddressFormModel.Country && showValidation
                              ? 'input-validation-error'
                              : styles.input,
                          )}
                          onBlur={(e) =>
                            formProgression(e, 'Profile address form', 'Country')
                          }
                        />
                        {!editAddressFormModel.Country &&
                          showValidation &&
                          content?.Model?.ContactDetailsConfiguration
                            ?.addressFields?.country === FieldType.Editable && (
                            <div className="row error">
                              <p className="text-danger">
                                {content?.PageData.MissingCountryError}
                              </p>
                            </div>
                          )}
                      </div>
                    </>
                  )}
              </div>
              <div className="Grid-cell  u-lg-size1of1 u-paddingVz">
                <div
                  className="Modal-infoText"
                  dangerouslySetInnerHTML={{
                    __html: content?.PageData?.Note,
                  }}
                />
              </div>
              <div className="Grid-cell  u-lg-size1of1">
                <div className="Customerdetails-modalButtons">
                  <div className="ButtonBar  ButtonBar--spaceBetween ButtonBar--row-reverse ">
                    <button
                      id="BTN_edit-adress"
                      type="submit"
                      className="Button editadressdetails"
                    >
                      <span>{content?.PageData?.SaveChangesButtonLabel}</span>
                    </button>
                    <button
                      type="button"
                      id="BTN_cancel-edit-adress"
                      onClick={() => onCancel()}
                      className="Button Button--gray js-modalclose"
                    >
                      <span>{content?.PageData?.CancelButtonLabel}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          {showUpdateFailedPopup && (
            <>
              <UpdatedFailedPopup
                onClose={() => setShowUpdateFailedPopup(false)}
                {...content}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditAddressPageData;
